module.exports = __webpack_public_path__ + "img/whatsapp_color.23f2df7.svg";